import "symbol-observable"; // Ensure Redux and DevTools share the same Symbol.observable reference
import { combineReducers, type AnyAction } from "redux";

import { reducer as currentAccount } from "./accounts/accountSlice";
import { reducer as currentNavigationOption } from "./navigation/navigationActions";
import { reducer as currentUser } from "./user/userActions";
import { reducer as propertyManagement } from "./propertyManagement/propertyManagementSlice";
import { reducer as sessionToken } from "./session/sessionActions";
import { reducer as uiState } from "./uiState";
import { reducer as documents } from "./documents";
import estates from "./estate";
import postings from "./postings";
import tickets from "./ticket";
import router from "./router/routerSlice";

const appReducer = combineReducers({
  currentAccount,
  currentNavigationOption,
  currentUser,
  estates,
  postings,
  propertyManagement,
  sessionToken,
  tickets,
  router,
  uiState,
  documents,
});

type RootState = ReturnType<typeof appReducer>;

// clear all data on logout
const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === "currentUser/clearUser") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
